import React,{useState,useEffect,useRef} from "react";
import {
    Badge,
    Button,
    Card,
    CardBody,
    Label,
    FormGroup,
    Input,
    Table,
    Row,
    Col,
    Modal,
    ModalBody,
    CustomInput,
  } from "reactstrap";
  import ReactBSAlert from "react-bootstrap-sweetalert";
  import {PENDING_CHANNELS,CHANNEL_TEMPLATES_APPROVE} from "../../constants"
import axios from "axios";
import NotificationAlert from "react-notification-alert";
import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";
import ResponsivePagination from "react-responsive-pagination";


let category = [
  { value: 1, label: "Marketing" },
  { value: 2, label: "Utility" },
  { value: 3, label: "Authentication" },
  { value: 4, label: "Service" },

];

const ChannelApproval=()=>{
    const [alert, setAlert] = useState(null);
    const [templates, setTemplates] = useState([]);
    const notificationAlertRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);


    useEffect(()=>{
      getPendingChannels(1);
    },[])

    const getPendingChannels=(pageNo)=>{
      setCurrentPage(pageNo);
      axios.get(PENDING_CHANNELS+ "?page=" + pageNo+"&status=0").then(res=>{setTemplates(res?.data)
        setIsLoading(false)
      }).catch((err)=>{
        let options={}
         options = {
          place: "tr",
          message: "Unable to fetch records",
          type: "warning",

          autoDismiss: 2,
        };
        notificationAlertRef?.current.notificationAlert(options);
        console.log(err)})
    }
    const confirmApproveChnl = (id,clientid,status) =>{
     
         setAlert(<ReactBSAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Are you sure?"
            onConfirm={() =>approveTemplate(id,clientid,status)}
            onCancel={() => setAlert(null)}
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            confirmBtnText={status===1?'Yes, Approve':'Yes, Reject'}
            cancelBtnText="Cancel"
            showCancel
            btnSize=""
          >
             {status===1?'You want to Approve This Template ?':'You want to Reject This Template'} 
          </ReactBSAlert>
          );
      }
 
      const approveTemplate=(id,clientid,status)=>{
        setIsLoading(true)
        let msg="";
        if(status===1){
          msg= "Approved Successfully"
        }else{
          msg= "Rejetced Successfully"
        }
        let payload = {
          id:id,
          client_id:clientid,
          status:status //0->Pending,1->Approve, 2-> Reject
        }
        axios.post(CHANNEL_TEMPLATES_APPROVE,payload).then(res=>{
          setIsLoading(false)
          let options={}
          options = {
           place: "tr",
           message: msg,
           type: "success",
 
           autoDismiss: 2,
         };
         notificationAlertRef?.current.notificationAlert(options);
         
         getPendingChannels(1);
         setAlert(false)
        }).catch(err=>console.log(err))
      }
    return (
      <>
        <div className="content pd-0 ">
        {alert}
          <Row className="Roles">
            <Card>
              <CardBody className="tableheightwf">
                <h3> Pending For  Approval</h3>
              <LoadingScreen
        children=""
        loading={isLoading}
        bgColor="rgba(0,0,0,0.7)"
        spinnerColor="#9ee5f8"
        textColor="#676767"
        logoSrc={logo}
        text="Loading..."
      ></LoadingScreen>
              <NotificationAlert ref={notificationAlertRef} />
                <Col sm="12">
                  <Row>
                    <Table responsive striped>
                      <thead>
                        <tr>
                          <th>Sno</th>
                          <th>Client</th>
                          <th>Channel</th>
                          <th>Template Id</th>
                          <th>Category </th>
                          <th>Sender Id</th>
                          <th>Content</th>
                          <th>Actions</th>
                        </tr>
                      </thead>

                      <tbody>
                        
                        {
                        templates?.data?.length>0?templates?.data?.map((item,index)=>{
                          
                            return(
                              <tr>
                                 <td style={{width: "5%"}}> {++index}</td>
                                 <td style={{width: "10%"}}> {item.company_name}</td>
                                 <td style={{width: "10%"}}> {item.channels_type}</td>
                                 <td style={{width: "10%"}}> {item.template}</td>
                                 <td style={{width: "10%"}}> {item?.category&&item?.category==1?"Marketing":category==2?"Utility":category==3?"Authentication":category==4?"Service":""}</td>
                                 <td style={{width: "10%"}}> {item.senderid}</td>
                                 <td style={{width: "10%"}}> {item.content}</td>
                                 <td style={{width: "15%"}}>
                                
                            <Badge
                              className="badge badge-warning"
                              color="success"
                              onClick={()=>confirmApproveChnl(item?.id,item?.client_id,1)}
                              style={{cursor:"pointer"}}
                            >
                              Aprove
                            </Badge>
                            <Badge
                              className="badge badge-warning"
                              color="error"
                              onClick={()=>confirmApproveChnl(item?.id,item?.client_id,2)}
                              style={{cursor:"pointer"}}
                            >
                              Reject
                            </Badge>
                          </td>
                              </tr>
                            )
                          }):<tr>
                            <td colSpan={8}>No Records Found</td>
                          </tr>

                        }
                        {/* <tr>
                            <td >TDR </td>
                            <td>Temp345</td>
                            <td>Temp</td>
                            <td>765432</td>
                          <td>
                            <Badge
                              className="badge badge-warning"
                              color="success"
                              onClick={()=>confirmdeleteUser(2)}
                              style={{cursor:"pointer"}}
                            >
                              Pending
                            </Badge>
                          </td>
                        </tr> */}
                      </tbody>
                    </Table>
                  </Row>
                </Col>
              </CardBody>
              {templates?.num_of_pages > 0 && (
              <div style={{ marginLeft: "auto", padding: "8px" }}>
                <ResponsivePagination
                  current={currentPage}
                  total={templates?.num_of_pages}
                  onPageChange={(newPage) => {
                    getPendingChannels(newPage);
                  }}
                />
              </div>
            )}
            </Card>
          </Row>
        </div>
      </>
    );
}

export default ChannelApproval;